module.exports = __webpack_public_path__ + "img/SH2D_300009.a4b55600.png";